import { Pipe, PipeTransform } from '@angular/core';
import { Environment } from 'src/components/shared-components/class/general-classes/environment';

@Pipe({
    name: 'orderByField',
    standalone: false
})


export class OrderByFieldPipe implements PipeTransform {

  transform(array: Array<any>, args: string): Array<any> {
    if (array == null) {
      return null;
    }

    array.sort((a: any, b: any) => {
      if (a[args] < b[args]) {
        //a is the Object and args is the orderBy condition (data.likes.count in this case)
        return -1;
      } else if (a[args] > b[args]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}